import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/languageContext';
import { getAnalyticsConsent, setAnalyticsConsent } from '../../lib/consent';
import { updateGtagConsent } from '../../lib/analytics';
import PrivacyNoticeModal from '../privacy/PrivacyNoticeModal';
import './ComplianceBanner.scss';

const ComplianceBanner: React.FC = () => {
  const { t } = useLanguage();
  const [consent, setConsent] = useState(getAnalyticsConsent());
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
    if (consent !== null) {
      updateGtagConsent(consent === 'granted');
    }
  }, [consent]);

  if (consent !== null) return null;

  const handleChoice = (nextConsent: 'granted' | 'denied') => {
    setAnalyticsConsent(nextConsent);
    updateGtagConsent(nextConsent === 'granted');
    setConsent(nextConsent);
  };

  return (
    <aside className="compliance-banner no-print" role="dialog" aria-live="polite" aria-label={t('complianceCookieTitle')}>
      <p className="compliance-banner__title">{t('complianceCookieTitle')}</p>
      <p className="compliance-banner__body">
        {t('complianceCookieBody')}{' '}
        <button
          type="button"
          className="compliance-banner__link"
          onClick={() => setPrivacyOpen(true)}
        >
          {t('complianceCookieNotice')}
        </button>
      </p>
      <div className="compliance-banner__actions">
        <button type="button" className="btn btn-sm btn-primary" onClick={() => handleChoice('granted')}>
          {t('complianceCookieAccept')}
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleChoice('denied')}>
          {t('complianceCookieReject')}
        </button>
      </div>

      <PrivacyNoticeModal show={privacyOpen} onHide={() => setPrivacyOpen(false)} />
    </aside>
  );
};

export default ComplianceBanner;
